import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import { connect, useSelector } from "react-redux";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  FloatingButton,
  Text,
  SwipeTabs,
  SwipeTab,
  Accordion,
} from "../../styles/Global";
import * as Global from "../../styles/Global";
import SwipeableViews from "react-swipeable-views-react-18-fix";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import { useRankingsQuery } from "../../services/playerApi";
import { FaUserCircle, FaQrcode } from "react-icons/fa";
import { AiFillSetting, AiOutlineCloseCircle } from "react-icons/ai";
import { BiEdit, BiLogInCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import "animate.css";
import "../../App.scss";
import GridTableSecure from "../../components/GridTableSecure";
import moment from "moment";
import LoginForm from "../player/loginWizard/LoginForm";
import SlideUp from "../../components/modals/SlideUp";
import { auth, db } from "../../services/firebaseConfig.js";
import { getAuth, signInWithCustomToken, signOut } from "firebase/auth";
import {
  collection,
  doc,
  setDoc,
  getDoc,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  onSnapshot,
  getFirestore,
  query,
  where,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import {
  setOrganizer,
  clearOrganizer,
} from "../../features/organizer/organizerSlice";
import { setRefreshOrganizerScreen } from "../../features/refreshScreen/refreshScreenSlice";
import useFirebaseAuth from "../../CustomHooks/useFirebaseAuth";
import useLocalStorage from "../../CustomHooks/useLocalStorage";
import SkeletonLoader from "../../components/SkeletonLoader";
import { OrganizerManagedDefs } from "../charts/columnDefs/columnDefs";
import { useGetProfileSingleMutation } from "../../services/organizerApi";
import { BsFillPlusCircleFill, BsCalculator } from "react-icons/bs";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GridCustomEvents from "../../components/GridCustomEvents";
import kcc from "../../assets/kcc_red.png";
import { clearModals, setModal } from "../../features/modals/modalSlice";
import { LicenseManager } from "@ag-grid-enterprise/core";
import AlertsSection from "./AlertsSection";
import { OpenAIFilled } from "@ant-design/icons";
import { IoMdOpen } from "react-icons/io";
import { OpenExternalURL } from "../../functions/helperFunctions.js";
import BannerLogo from "../../components/BannerLogo.jsx";
import { gridGodpowerColDefs } from "../charts/columnDefs/GodpowerColDefs.jsx";
import GridTableClientInsecure from "../../components/GridTableClientInsecure.jsx";
import GridTableClientSecure from "../../components/GridTableClientSecure.jsx";
LicenseManager.setLicenseKey(
  "CompanyName=Scoreholio Inc,LicensedApplication=Scoreholio,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-036853,SupportServicesEnd=6_March_2026_[v2]_MTc3Mjc1NTIwMDAwMA==c1e9b989582d1581fc31da5b0be0f677"
);
const mapDispatch = {
  setOrganizer,
  setRefreshOrganizerScreen,
  clearModals,
  clearOrganizer,
  setModal,
};

const Godpower = ({ setOrganizer, setModal }) => {
  const sport = new URL(window.location.href).pathname.split("/")[2];
  const params = new URLSearchParams(window.location.search);
  const allAccessUsers = [
    "PdejK7ZzhMM5nGJPl6QP57wBXBB2",
    "FD2x0TUi1qTD78xj3vdFcSnzW102", //Phil Main
    "irpWsXBhjQRFhK8pNrtnarqDpeF2",
    "ykQkJvXkI6U5nxuAqDyz82z5Fdt1", //Ben
    "AxNqt2L9sYhyme7ucfrfUpMlQVL2", //Kristen
    "YG6V01K5b4VtFwi4GgswLNyAgZD3", //James
  ];
  const { origin, pathname } = new URL(window.location);
  console.log("origin: ", origin);
  console.log("pathname: ", pathname);
  const navigate = useNavigate();
  const orgModals = useSelector((state) => state.modal.orgModals);
  const globalModals = useSelector((state) => state.modal.globalModals);
  const globalModals2 = useSelector((state) => state.modal.globalModals2);
  const orgTournamentInfo = useSelector(
    (state) => state.modal.orgTournamentInfo
  );
  const OrganizerState = useSelector((state) => state.organizer);
  console.log("OrganizerState: ", OrganizerState);
  const organizer = useSelector((state) => state.organizer.organizerData);
  const localStorageOrganizer =
    JSON.parse(localStorage.getItem("organizer")) || organizer;
  console.log("localStorageOrganizer: ", localStorageOrganizer);
  const account = useSelector((state) => state.organizer.accountid);
  const platform = useSelector((state) => state.organizer.platform);
  const build = useSelector((state) => state.organizer.build);
  const bearerToken = useSelector((state) => state.organizer.bearerToken);
  const [allowTabClicks, setAllowTabClicks] = useState(false);
  const [dataCallBody, setDataCallBody] = useState({
    type: params.get("uid") && params.get("uid") !== "" ? "Organizer" : null,
    accountid:
      params.get("uid") && params.get("uid") !== "" ? params.get("uid") : null,
    dateGte: "now/d",
    dateLte: "now+3d/d",
    env: window.location.hostname.startsWith("beta.scoreholio.com")
      ? "beta"
      : "production",
    userAgent: navigator.userAgent,
  });

  // Check for token parameter and show modal if it exists
  useEffect(() => {
    const tokenParam = params.get("token");
    console.log("godpower tokenParam: ", tokenParam);
    if (tokenParam && tokenParam !== "") {
      setModal({
        orgModals: {
          showModal: true,
          data: {},
          modalType: 53,
        },
      });
    }
  }, [setModal]);

  useEffect(() => {
    console.log("setOrganizer(localStorageOrganizer): ", localStorageOrganizer);
    const storedOrganizer = {
      ...localStorageOrganizer,
    };
    setOrganizer(storedOrganizer);
  }, []);

  // Add screen width detection with JavaScript
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Add useEffect to track window width changes
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const BackButton = ({ hide, style }) => {
    const handleClick = () => {
      if (!hide) {
        // Remove godpower parameter from URL
        const url = new URL(window.location);
        url.searchParams.delete("godpower");
        window.history.replaceState({}, "", url);
        // Then set organizer state
        setOrganizer({ isGodPower: false });
      }
    };

    return (
      <LargeButtonSecondary
        onClick={handleClick}
        style={{
          borderRadius: 5,
          padding: 5,
          margin: "10px 0 0 0",
          opacity: hide ? 0 : 1,
          cursor: hide ? "default" : "pointer",
          ...style,
        }}
      >
        <ButtonText secondary style={{ fontSize: ".9em" }}>
          ← Back
        </ButtonText>
      </LargeButtonSecondary>
    );
  };

  const isAuthorized =
    organizer &&
    (organizer.isAdmin === "true" ||
      organizer.isAdmin === true ||
      allAccessUsers.includes(organizer.uid));

  useEffect(() => {
    if (organizer && !isAuthorized) {
      // Remove godpower parameter from URL and reload
      setTimeout(() => {
        const url = new URL(window.location);
        url.searchParams.delete("godpower");
        window.location.href = url.toString();
      }, 3000);
    }
  }, [organizer, isAuthorized]);

  return (
    organizer && (
      <>
        <FlexRow
          style={{
            width: "100%",
            flex: 0,
            padding: 20,
          }}
          align="center"
          justify="space-between"
        >
          {windowWidth > 699 && <BackButton />}
          <FlexColumn
            // style={{ width: "100%", padding: "0 20px 20px 20px" }}
            align="center"
            justify="center"
          >
            <BannerLogo />
            <FlexRow align="center" justify="center">
              {windowWidth < 699 && (
                <BackButton style={{ margin: "0 5px 0 0" }} />
              )}
              <Text>{organizer.displayName}</Text>
            </FlexRow>
          </FlexColumn>

          {windowWidth > 699 && <BackButton hide />}
        </FlexRow>
        <ContentSection
          style={{
            width: "100%",
            maxWidth: 1350,
            margin: "0 auto",
            padding: "5px 0",
          }}
          className="bagStats godpowerSection"
        >
          {!isAuthorized ? (
            <FlexColumn
              align="center"
              justify="center"
              style={{
                padding: "50px 20px",
                textAlign: "center",
              }}
            >
              <Text
                style={{
                  fontSize: "1.5em",
                  marginBottom: "20px",
                  color: Global.red,
                }}
              >
                Unauthorized user
              </Text>
              <Text style={{ fontSize: "1.2em", color: Global.blueLight }}>
                Redirecting
                <span
                  style={{
                    animation: "ellipsis 1.5s infinite",
                  }}
                >
                  ...
                </span>
              </Text>
              <style jsx>{`
                @keyframes ellipsis {
                  0% {
                    opacity: 0;
                  }
                  25% {
                    opacity: 1;
                  }
                  50% {
                    opacity: 0;
                  }
                  75% {
                    opacity: 1;
                  }
                  100% {
                    opacity: 0;
                  }
                }
              `}</style>
            </FlexColumn>
          ) : (
            <GridTableClientSecure
              id="grid-organizer-managed"
              apiURL="admin/godpower-tournaments"
              columnDefs={gridGodpowerColDefs}
              dataCallBody={dataCallBody}
              paginationPageSize="16"
              showSearchBar={true}
              showFilter={false}
              setAllowTabClicks={setAllowTabClicks}
              rowHeight={30}
              isGodPower={true}
              setDataCallBody={setDataCallBody}
              windowWidth={windowWidth}
            />
          )}
        </ContentSection>
      </>
    )
  );
};

export default connect(null, mapDispatch)(Godpower);
